export default "__VITE_ASSET__DM_lfb_z__"